import React from 'react';
import { services } from '../mock/mockData';
import { Brain, Heart, Sparkles } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  Brain: Brain,
  Heart: Heart,
  Sparkles: Sparkles
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 bg-white relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-rose-100 rounded-full blur-3xl opacity-30 -z-0"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold-100 rounded-full blur-3xl opacity-20 -z-0"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-rose-900 mb-4">
            Serviços
          </h2>
          <p className="text-lg text-gray-600">
            Oferecemos acompanhamento psicológico especializado e personalizado
            às suas necessidades individuais.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 border-rose-100 hover:border-rose-300 hover:-translate-y-2 bg-white/80 backdrop-blur-sm"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                <CardHeader>
                  <div className="w-14 h-14 bg-gradient-to-br from-rose-100 to-gold-100 rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="h-7 w-7 text-rose-600" />
                  </div>
                  <CardTitle className="text-2xl text-rose-800 group-hover:text-rose-600 transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-gray-600 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-rose-50 border border-rose-200 rounded-2xl px-8 py-6 max-w-2xl">
            <p className="text-gray-700 leading-relaxed">
              <strong className="text-rose-700">Público-alvo:</strong> Terapia individual
              especializada para <span className="text-rose-600 font-semibold">jovens adultos e adultos</span>,
              oferecendo um espaço seguro para crescimento pessoal e bem-estar emocional.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
